import React, { Component } from "react";
import { ButtonToolbar, DropdownButton, MenuItem } from "react-bootstrap";
import Moment from "react-moment";
import DealStatuses from '../Actions/dealStatuses';
import RegistrationActions from '../Actions/registrationActions';
import AuthContext from '../auth-context';
import ConfirmButton from '../Shared/ConfirmButton';

class RegistrationButtonBar extends Component {
  static contextType = AuthContext;

  render() {
    const { deal, seminarsToRescheduleTo, handleDealUpdated } = this.props
    const authStore = this.context

    const actions = new RegistrationActions(deal, handleDealUpdated)
    const dealStatuses = new DealStatuses(deal, authStore)
    const showButtons = dealStatuses.registrationStatuses.buttons
    const statuses = dealStatuses.registrationStatuses.statuses

    if (statuses.dealCompleted) return <div>Deal completed</div>
    if (statuses.noRegistration) return  <div>No registration</div>
    if (statuses.registrationCompleted) return <div>Registration Completed</div>
    if (showButtons.noButtonsToShow) return <div>nothing to see here</div>

    return (
      <div style={{marginTop:6}}>
        <ButtonToolbar>
        {showButtons.markAttendeeConfirmed && <ConfirmButton text='Attendee Confirmed' okAction={(note) => actions.registrationMarkAttendeeConfirmed(note) } />}
        {showButtons.markAttendeeNotConfirmed && <ConfirmButton text="Couldn't Confirm" okAction={(note) => actions.registrationMarkAttendeeNotConfirmed(note) } />}
        {showButtons.markSeminarAttended && <ConfirmButton text='Attended' okAction={(note) => actions.registrationMarkSeminarAttended(note) } />}
        {showButtons.markSeminarNotAttended && <ConfirmButton text='Did Not Attend' okAction={(note) => actions.registrationMarkSeminarNotAttended(note) } />}
        {showButtons.markRegistrationCancelled && <ConfirmButton bsStyle='warning' text='Cancel' okAction={(note) => actions.registrationMarkRegistrationCancelled(note) } />}


          {showButtons.reschedule && <DropdownButton id='reschedule' bsStyle='info' bsSize="xsmall" title='Reschedule' key='reschedule'>
            {seminarsToRescheduleTo ? seminarsToRescheduleTo.map((seminar) => <MenuItem eventKey={seminar.id} key={seminar.id} onClick={() => actions.registrationConfirmReschedule(seminar)}><Moment format="MMM Do YYYY">{seminar.at}</Moment> {seminar.region === 'ZOOM_WEBINAR' && <> WEBINAR: </>}{seminar.location}, {seminar.address} ({seminar.registrations}/{seminar.capacity})</MenuItem>) : null}
            {seminarsToRescheduleTo ? seminarsToRescheduleTo.length === 0 ? (<MenuItem disabled>No available dates</MenuItem>) : null : null}
          </DropdownButton>
          }
        </ButtonToolbar>
        </div>
    )
  }
}

export default RegistrationButtonBar